import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSubscript: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="subscript">
      <path
        d="M21 20H17C17 18.1159 21 16.798 21 14.9309C21 13.7674 20.1098 13 19.0052 13C18.0383 13 17.3801 13.5837 17.1243 14.3478"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6L13 18M13 6L3 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconSubscript;
